package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val BlueColorVariant = ColorVariant(
    n100 = Color(0xFFE9F2FF),
    n200 = Color(0xFFCCE0FF),
    n300 = Color(0xFF85B8FF),
    n400 = Color(0xFF579DFF),
    n500 = Color(0xFF388BFF),
    n600 = Color(0xFF1D7AFC),
    n700 = Color(0xFF0C66E4),
    n800 = Color(0xFF0055CC),
    n900 = Color(0xFF09326C),
    n1000 = Color(0xFF1C2B41)
)
